import React from "react";
import { useParams } from "react-router-dom";
import RolePanel from "./RolePanel";

export default function UserRoleList() {
  const { userId } = useParams();
  return <RolePanel userId={userId!} showBackButton={true} />;
}
